<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!callRateCalculationId"> {{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="callRateCalculationId"> {{'app.editTile' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-12">

            <label class="control-label">{{'labels.businessUnit' |translate}} </label>
            <span class="ui-fluid">
              <ng-multiselect-dropdown placeholder="{{'labels.businessUnit' | translate}}"
                                       [data]="businessUnits"
                                       name="bu"
                                       #bu="ngModel"
                                       (onSelect)="onChangeBu()"
                                       (onDeSelect)="onChangeBu()"
                                       (onSelectAll)="onSelectAllBussinessUnits($event)"
                                       (onDeSelectAll)="onSelectAllBussinessUnits($event)"
                                       [(ngModel)]="callRateCalculation.businessUnitIds"
                                       [settings]="dropdownSettings">
              </ng-multiselect-dropdown>
            </span>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.valid, 'has-error' : (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid}">
              <label class="control-label">{{'items.StartDate' | translate}} </label>

              <div class="input-group date">
                <input class="form-control" placeholder="yyyy-mm-dd" required
                       name="startDatePicker" #startDatePicker="ngModel"
                       [(ngModel)]="startDate" ngbDatepicker #dpYMD="ngbDatepicker">
                <span class="input-group-btn date-label">
                  <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </span>


              </div>
              <div *ngIf="(startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.valid, 'has-error' : (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid}">
              <label class="control-label">{{'items.endDate' | translate}} </label>

              <div class="input-group date">
                <input class="form-control" placeholder="yyyy-mm-dd" [minDate]="startDate"
                       name="endDatePicker" #endDatePicker="ngModel"
                       [(ngModel)]="endDate" ngbDatepicker #dpYMD1="ngbDatepicker">

                <span class="input-group-btn date-label">
                  <button class="btn date-btn" (click)="dpYMD1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </span>


              </div>
              <div *ngIf="(endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>


          <div class="col-sm-6">
            <label class="control-label">{{'Numerator' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="numeratorTypes"
                          name="numerator" #numerator="ngModel"
                          styleClass="wid100"
                          placeholder="Numerator"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="callRateCalculation.numeratorType"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="name"></p-dropdown>
            </span>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'Denominator' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="denominatorTypes"
                          name="denominator" #denominator="ngModel"
                          styleClass="wid100"
                          placeholder="Denominator"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="callRateCalculation.denominatorType"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="name"></p-dropdown>
            </span>
          </div>

        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




